import useRights from "../../../shared/functions/useRights";
import useStyles from "./styles";
import {keys} from 'lodash';
import {Checkbox, Grid, Stack, Typography} from "@mui/material";

export default function UserDetailsRightsSection({rights, loading = false, onChange}) {
    const classes = useStyles()
    const {RIGHTS} = useRights()
    // console.log("object UserDetailsRightsSection"+ JSON.stringify(rights));
    const data = rights ? ({...RIGHTS, ...rights}) : RIGHTS

    const handleAdminStateChange = (state) => {
        // console.log({...data, Admin: state})
        onChange && onChange({...data, Admin: state})
    }
    const handleChange = (_,__,___ ) => {

        const formated = {...data,[_]:{...data[_],[__]:___}}

        onChange && onChange(formated)
    }


    return (
        <>
            <h5 className={classes.subTitle}>
                Droits d'acces
            </h5>

            {
                Object.keys(RIGHTS).map((key, index) => {
                    switch (key === 'Admin') {
                        case false:
                            return (
                                <Stack direction={'column'} spacing={2}>
                                    <Typography variant={'subtitle1'}>
                                        {key}
                                    </Typography>

                                    <Grid container spacing={1}>
                                        {

                                            keys(data[key]).map((one, index) => (
                                                <Grid item xs={3} key={`'autod - ${index}`}>
                                                    <Stack direction={'row'} spacing={1}
                                                           style={{marginBottom: 30}}>
                                                        <Checkbox checked={data[key][one]}
                                                                  onChange={({target: {checked}}) => handleChange(key,one,checked)}/>
                                                        <Typography variant={'body1'}>
                                                            {one}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            ))
                                        }
                                    </Grid>

                                </Stack>
                            );

                        case true:
                            return (
                                <Stack direction="row" spacing={1} key={`'auto - ${index}`} style={{ marginBottom: 30 }}>
                                    <Checkbox checked={data.Admin} onChange={({ target: { checked } }) => handleAdminStateChange(checked)} />
                                    <Typography variant="body1">
                                        Admin
                                    </Typography>
                                </Stack>
                            )
                        default :
                            return <></>
                    }

                })
            }

        </>
    )
}